import React from 'react';
import { useTranslation } from '@jupiter-app/plugin-i18n';
import styles from './index.scss';
import dayjs from 'dayjs';

interface WebinarCardProps {
  id: number;
  image: string;
  name: string;
  createTime: number;
  views?: number;
  onClick?: () => void;
}

const WebinarCard: React.FC<WebinarCardProps> = props => {
  const { onClick, image, name, createTime, views } = props;
  const { t } = useTranslation();

  const handleClick = () => {
    onClick && onClick();
  };
  return (
    <div className={styles.cardContainer} onClick={handleClick}>
      <div className={styles.cardImage}>
        <img src={image} />
      </div>
      {createTime && (
        <div className={styles.cardTags}>
          {dayjs(createTime).format('MMMM D, YYYY')}
        </div>
      )}
      <div className={styles.cardTitle}>{name}</div>
      <div className={styles.cardFooter}>
        {views + ' ' + t('academy_homepage_module_views')}{' '}
      </div>
    </div>
  );
};

export default WebinarCard;
